import { SxProps, Theme } from "@mui/material";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../setup/constants";
interface ILogoCompProps {
  sx?: SxProps<Theme>;
}
export const DarkLogo = (props: ILogoCompProps) => {
  const navigate = useNavigate();
  return (
    <Box
      onClick={() => {
        navigate(ROUTES.HOME);
      }}
      component="img"
      src="/assets/images/svg/waffyLogo.svg"
      sx={props.sx}
    />
  );
};
export const WhiteLogo = (props: ILogoCompProps) => {
  const navigate = useNavigate();
  return (
    <Box
      onClick={() => {
        navigate(ROUTES.HOME);
      }}
      component="img"
      src="/assets/images/svg/whiteWaffyLogo.svg"
      sx={props.sx}
    />
  );
};
